import React from 'react'
import EmiCalculator from '../../components/EmiCalculator';
import { MenuFunction,FooterFunction } from "../../utils/menu";
import {configuration} from "../../helpers/config";
import { getDealerData } from '../../utils/GenUtils';
import axios from "axios";
export async function getServerSideProps(context) {
  // const { req } = context;
  // const currentUrl = `${req.headers.host}`;
  // const apiData = await axios.get(
  //   `${configuration.APP_URL_CONTENTS}/dealer-code?url=${currentUrl}`,
  // );
  
  const { req } = context;
  const protocol = req.headers['x-forwarded-proto'] || 'http';
  const host = req.headers.host;
  let currentUrl = `${protocol}://${host}/`;
  
  const apiData = await getDealerData(currentUrl);
  const lobData = apiData?.data?.result?.[0] || "" ;
  try {
    const Menudata = await MenuFunction(lobData?.dealerCode);
    const Footerdata = await FooterFunction(lobData?.dealerCode);
    return {
      props: {
        Menudata:Menudata,
        Footerdata:Footerdata,
      },
    };
  } catch (err) {
    console.warn(err, "Error Data"); 
    return {
      props: {
        error: true,
      },
    };
  }
}


const Emi_Calculator = (props) => {
    return (
        <>
        <EmiCalculator /> 
        </>
      );
}

export default Emi_Calculator